import React from 'react';
import styles from './GeneratingOverlay.module.scss';

interface GeneratingOverlayProps {
    visible: boolean;
    statusMessage?: string | null;
}

const GeneratingOverlay: React.FC<GeneratingOverlayProps> = ({ visible, statusMessage }) => {
    if (!visible) return null;

    const displayText = statusMessage || 'Generating great designs...';

    return (
        <div className={styles['overlay']}>
            <div className={styles['outer-card']}>
                <div className={styles['inner-card']}>
                    <div className={styles['scroll-viewport']}>
                        <div className={styles['scroll-track']}>
                            <div className={styles['bar-group']}>
                                <div className={`${styles['bar']} ${styles['bar--1']}`} />
                                <div className={`${styles['bar']} ${styles['bar--2']}`} />
                                <div className={`${styles['bar']} ${styles['bar--3']}`} />
                                <div className={`${styles['bar']} ${styles['bar--4']}`} />
                                <div className={`${styles['bar']} ${styles['bar--5']}`} />
                            </div>
                            <div className={styles['bar-group']}>
                                <div className={`${styles['bar']} ${styles['bar--1']}`} />
                                <div className={`${styles['bar']} ${styles['bar--2']}`} />
                                <div className={`${styles['bar']} ${styles['bar--3']}`} />
                                <div className={`${styles['bar']} ${styles['bar--4']}`} />
                                <div className={`${styles['bar']} ${styles['bar--5']}`} />
                            </div>
                        </div>
                    </div>
                    <div className={styles['icon-anchor']} />
                </div>
                <p className={styles['generating-text']} key={displayText}>
                    {displayText}
                </p>
            </div>
        </div>
    );
};

export default GeneratingOverlay;
